<template>
  <div class="reg-page" style="">
    <div class="reg-card">
      <div class="reg-logo"><img src="/assets/images/CHECK-APP.png" alt="Check-App" class="logo-img" /></div>

      <!-- Verify pending (no token in URL) -->
      <template v-if="!verifying">
        <div class="icon-wrap"><i class="fas fa-envelope-open-text verify-icon"></i></div>
        <h1 class="reg-title">{{ $t('verifyEmailTitle') }}</h1>
        <p class="reg-subtitle">{{ $t('verifyEmailMsg') }}</p>
        <router-link :to="`/${$i18n.locale}/register/login`" class="btn-primary btn-block">
          {{ $t('signIn') }}
        </router-link>
      </template>

      <!-- Auto-verify from link -->
      <template v-else>
        <div v-if="loading" class="text-center py-8">
          <i class="fas fa-spinner fa-spin fa-2x text-blue-500"></i>
          <p class="mt-3 text-gray-500">{{ $t('loading') }}</p>
        </div>
        <template v-else-if="success">
          <div class="icon-wrap success"><i class="fas fa-check-circle verify-icon text-green-500"></i></div>
          <h1 class="reg-title">{{ $t('emailVerifiedTitle') }}</h1>
          <p class="reg-subtitle">{{ $t('emailVerifiedMsg') }}</p>
          <router-link :to="`/${$i18n.locale}/register/login`" class="btn-primary btn-block">
            {{ $t('signIn') }}
          </router-link>
        </template>
        <template v-else>
          <div class="icon-wrap error"><i class="fas fa-times-circle verify-icon text-red-500"></i></div>
          <h1 class="reg-title">Verification Failed</h1>
          <p class="reg-subtitle">{{ error }}</p>
          <router-link :to="`/${$i18n.locale}/register`" class="btn-primary btn-block">
            {{ $t('createAccount') }}
          </router-link>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';

const route    = useRoute();
const verifying = ref(false);
const loading  = ref(false);
const success  = ref(false);
const error    = ref('');

const REG_API = process.env.VUE_APP_REGISTRATION_API_URL || '/api/registration';

onMounted(async () => {
  const { user_id, token } = route.params;
  if (!user_id || !token) return;
  verifying.value = true;
  loading.value = true;
  try {
    const res = await fetch(`${REG_API}/verify-email/${user_id}/${token}/`);
    const data = await res.json();
    if (res.ok) success.value = true;
    else error.value = data.error || 'Verification failed.';
  } catch {
    error.value = 'Network error. Please try again.';
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
.reg-page { min-height:100vh; display:flex; align-items:center; justify-content:center;
  background:linear-gradient(135deg,#f0f4ff 0%,#e8f5e9 100%); padding:20px; }
.reg-card { background:#fff; border-radius:16px; box-shadow:0 8px 32px rgba(0,0,0,.1);
  padding:40px; width:100%; max-width:440px; text-align:center; }
.reg-logo { margin-bottom:24px; }
.logo-img { height:60px; }
.icon-wrap { margin-bottom:16px; }
.verify-icon { font-size:3.5rem; color:#1a3a5c; }
.reg-title { font-size:1.5rem; font-weight:700; color:#1a3a5c; margin-bottom:10px; }
.reg-subtitle { color:#6b7280; margin-bottom:28px; font-size:.95rem; line-height:1.6; }
.btn-primary { display:block; background:#1a3a5c; color:#fff; border:none; border-radius:10px;
  padding:13px; font-size:1rem; font-weight:600; cursor:pointer; text-decoration:none;
  text-align:center; transition:background .2s; }
.btn-primary:hover { background:#2d6a9f; }
.btn-block { width:100%; }
.py-8 { padding-top:2rem; padding-bottom:2rem; }
.text-center { text-align:center; }
.mt-3 { margin-top:.75rem; }
</style>